import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { settingsApi } from "../api/resources";
import { useAuth } from "./AuthContext";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);

  const reload = useCallback(() => {
    if (!user) return;
    settingsApi.get().then(setSettings);
  }, [user]);

  useEffect(() => {
    reload();
  }, [reload]);

  return <SettingsContext.Provider value={{ settings, reload }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
